import(/* webpackMode: "eager" */ "/var/directorder/app/main/apps/seller/src/app/(auth)/login/[[...mode]]/page.js");
